import { create } from "zustand"

interface InfoPanelStore {
  isOpen: boolean
  togglePanel: () => void
}

const useInfoPanelStore = create<InfoPanelStore>((set) => ({
  isOpen: true,
  togglePanel: () => set((state) => ({ isOpen: !state.isOpen })),
}))

export default useInfoPanelStore
